(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ios26-glass-mobile-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.glass-mobile-nav__surface').forEach((surface) => {
      if (surface.dataset.dragReady === 'true') return;
      surface.dataset.dragReady = 'true';

      const mobileNav = surface.closest('.glass-mobile-nav');

      if (mobileNav && mobileNav.parentElement !== document.body) {
        document.body.appendChild(mobileNav);
      }

      const lens = surface.querySelector('.glass-mobile-nav__lens');
      const items = Array.from(surface.querySelectorAll('.glass-mobile-nav__item'));
      let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      let startX = 0;
      let lensStartX = 0;
      let currentX = 0;
      let dragging = false;
      let moved = false;

      const metrics = () => {
        const rect = surface.getBoundingClientRect();
        return { slot: (rect.width - 8) / items.length, max: ((rect.width - 8) / items.length) * (items.length - 1) };
      };

      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(items.length - 1, index));
        items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
      };

      const placeLens = (x, scale = 1) => {
        currentX = x;
        lens.style.transform = `translate3d(${x}px, 0, 0) scaleX(${scale})`;
      };

      const snap = (index, navigate = false) => {
        const { slot } = metrics();
        setActive(index);
        surface.classList.remove('is-dragging');
        surface.classList.add('is-settling');
        placeLens(slot * activeIndex, 1);
        window.setTimeout(() => {
          surface.classList.remove('is-settling');
          if (navigate) window.location.assign(items[activeIndex].href);
        }, 340);
      };

      const begin = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        const { slot } = metrics();
        dragging = true;
        moved = false;
        startX = event.clientX;
        lensStartX = slot * activeIndex;
        surface.classList.remove('is-settling');
        surface.classList.add('is-dragging');
        surface.setPointerCapture(event.pointerId);
      };

      const move = (event) => {
        if (!dragging) return;
        const { slot, max } = metrics();
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 2) moved = true;
        const rawX = lensStartX + delta;
        const resistedX = rawX < 0 ? rawX * .18 : rawX > max ? max + (rawX - max) * .18 : rawX;
        const velocityStretch = 1 + Math.min(Math.abs(delta) / slot, 1) * .08;
        placeLens(resistedX, velocityStretch);
        setActive(Math.round(Math.max(0, Math.min(max, resistedX)) / slot));
      };

      const end = (event) => {
        if (!dragging) return;
        dragging = false;
        if (surface.hasPointerCapture(event.pointerId)) surface.releasePointerCapture(event.pointerId);
        snap(activeIndex, moved);
      };

      surface.addEventListener('pointerdown', begin);
      surface.addEventListener('pointermove', move);
      surface.addEventListener('pointerup', end);
      surface.addEventListener('pointercancel', end);
      surface.addEventListener('click', (event) => {
        if (moved) event.preventDefault();
      }, true);

      window.addEventListener('resize', () => snap(activeIndex));
      requestAnimationFrame(() => snap(activeIndex));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
